import useTypedSelector from './useTypedSelector';
import {ActionType as AuthActionType} from '../../auth/state/action';
import {useFetchInfo} from '../util/fetch';

export default function useLogin() {
  const [user, isFetchUserFinished, apiParamsAuthResult] = useTypedSelector(
    state => [
      state.auth.user,
      state.auth.isFetchUserFinished,
      state.auth.apiParamsAuthResult,
    ]
  );

  const {isFetching: isFetchingFinish} = useFetchInfo(
    AuthActionType.FetchFinish
  );

  const isLogin = isFetchUserFinished && !isFetchingFinish ? !!user : undefined;

  return {
    isLogin: !!isLogin,
    isLoginChecking: isLogin === undefined || !!apiParamsAuthResult,
  };
}
